export default {
  notSupported: 'Die Rezeptverwaltung ist für diesen Ofentyp nicht verfügbar.',
};
